import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import { Finanzmanager, MeinBedarf } from '@/application/router/types/types';
import { useUnreadHintStore } from '@/application/store/unreadHintStore';
import { useBaseDataStore } from '@/user/store/baseDataStore';
import { UnreadHintType } from "@/api/unreadHint/types";
import { storeToRefs } from "pinia";
import type { NavigationItem } from "@/application/menu/composables/types";
import { useRoute } from 'vue-router';

export function useMenuItems(): { items: ComputedRef<NavigationItem[]>, isLoading: ComputedRef<boolean> } {
  const { isCompany, isBroker, isMagicLogin } = storeToRefs(useBaseDataStore());
  const unreadHints = useUnreadHintStore();

  const isLoading = computed(() => isCompany.value === null);

  const items = computed(() => (isMagicLogin.value ? [
    {
      id: Finanzmanager.CHECKUP,
      title: 'Check-up',
      to: () => ({ name: Finanzmanager.CHECKUP }),
      unreadHints: null,
    },
  ] : [
    {
      id: Finanzmanager.CHECKUP,
      title: 'Check-up',
      to: () => ({ name: Finanzmanager.CHECKUP }),
      unreadHints: null,
    },
    {
      id: Finanzmanager.BEDARF,
      title: 'Bedarf',
      to: () => {
        const route = useRoute();
        const { bedarfHash } = route.params;
        if (bedarfHash) {
          return { name: MeinBedarf.UEBERSICHT, params: { bedarfHash } };

        }
        return { name: Finanzmanager.BEDARF };
      },
      unreadHints: null,
    },
    {
      id: Finanzmanager.VERTRAEGE,
      title: 'Verträge',
      to: () => ({ name: Finanzmanager.VERTRAEGE }),
      unreadHints: unreadHints[UnreadHintType.Contract].size
    },
    {
      id: Finanzmanager.DOKUMENTE,
      title: 'Dokumente',
      to: () => ({ name: Finanzmanager.DOKUMENTE }),
      unreadHints: unreadHints[UnreadHintType.Document].size
    },
    {
      id: Finanzmanager.BANKING,
      title: 'Banking',
      to: () => ({ name: Finanzmanager.BANKING }),
      unreadHints: null,
    },
  ]).filter(({ id }) => {
    if (id === Finanzmanager.CHECKUP) return isCompany.value === false;
    if (id === Finanzmanager.BANKING) return !isBroker.value;
    return true;
  }));

  return { items, isLoading };
}
